import { Link } from "react-router-dom";
import { Settings, Building2, UserCheck, TrendingUp, Hospital } from "lucide-react";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { adminSystemStats } from "../../data/adminDashboard";
import { adminSystemStatRoutes } from "../../navigation/dashboardRoutes";

const statIcons = {
  hospital: Hospital,
  building: Building2,
  auditor: UserCheck,
  rate: TrendingUp,
};

type SystemStat = {
  id: string;
  value: string | number;
  icon: keyof typeof statIcons;
};

export function SystemStatsWidget({
  stats = adminSystemStats as unknown as SystemStat[],
}: {
  stats?: SystemStat[];
}) {
  const { t } = useTranslation();
  const labels = t.safecheck.adminDashboard.systemStats.labels;

  return (
    <div className="theme-card theme-card-static p-5">
      <div className="mb-5 flex items-center gap-2">
        <Settings size={16} className="text-muted" />
        <h3 className="text-sm font-semibold text-foreground">
          {t.safecheck.adminDashboard.systemStats.title}
        </h3>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {stats.map((stat) => {
          const Icon = statIcons[stat.icon];
          const label = labels[stat.id as keyof typeof labels] ?? stat.id;

          return (
            <Link
              key={stat.id}
              to={adminSystemStatRoutes[stat.id as keyof typeof adminSystemStatRoutes] ?? "/dashboard"}
              className="hover-zoom flex items-center gap-4 rounded-xl border border-border bg-card-muted/30 px-4 py-4 transition-all hover:border-accent/40 hover:bg-card-muted/60"
            >
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-soft">
                <Icon size={20} className="text-primary" strokeWidth={1.75} />
              </div>
              <div>
                <p className="text-sm text-muted">{label}</p>
                <p className="mt-0.5 text-xl font-bold text-foreground">{stat.value}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
